import React, { useEffect, useState } from 'react';
import { Button } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { useMyContext } from '../../../../context/MyContext';
import Sidebar from '../../../../component/b2b/sideBar/b2bSideBar';
import NavBar from '../../../../component/b2b/navBar/b2bNavBar';
import '../../../../css/custom-scrollbar.css';
import { Base_Url, b2bRateCard } from '../../../../config/config';
import { FcMoneyTransfer } from "react-icons/fc";
import { toast } from 'react-toastify';



const B2BRateCard = () => {
  const [zoneMetrics, setZoneMetrics] = useState({});
  const [showZoneInfo, setShowZoneInfo] = useState({});
  const { isDarkMode, isToggleSidebar } = useMyContext();
  const [data, setData] = useState([]);
  const [expandedPartner, setExpandedPartner] = useState(null);
  const [showVasCharges, setShowVasCharges] = useState({});
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();
  const token = localStorage.getItem('token');
  const cus_id = localStorage.getItem('cus_id');

  const zoneMapping = {
    'n1': 'N1', 'n2': 'N2', 'n3': 'N3', 'n4': 'N4',
    'c1': 'C1', 'c2': 'C2',
    'w1': 'W1', 'w2': 'W2',
    's1': 'S1', 's2': 'S2', 's3': 'S3', 's4': 'S4',
    'e1': 'E1', 'e2': 'E2',
    'ne1': 'NE1', 'ne2': 'NE2'
  };

  useEffect(() => {
    fetchRateCardList();
  }, []);

  const handleNavigation = () => {
    navigate('/dashboard');
  };

  const fetchRateCardList = async () => {
    try {
      setLoading(true);
      const url = Base_Url + b2bRateCard;
      const response = await fetch(url, {
        method: 'GET',
        headers: {
          token: token || '',
          cus_id: cus_id || '',
          'Content-Type': 'application/json',
        },
      });
      const result = await response.json();

      if (result.status === "SUCCESS") {
        setData(result.data);
        setZoneMetrics(result.zonemetrics || {}); // Set zone metrics from API
        if (result.data.length > 0) {
          setActivePartner(result.data[0].partner);
        }
      } else {
        toast.error(result.message);
      }
    } catch (error) {
      toast.error('Error fetching rate card data: ' + error.message);
    } finally {
      setLoading(false);
    }
  };

  const [activePartner, setActivePartner] = useState(data.length > 0 ? data[0].partner : null);

  const parsePricingData = (pricingString) => {
    try {
      return JSON.parse(pricingString);
    } catch (error) {
      console.error('Error parsing pricing data:', error);
      return {};
    }
  };

  const parseVasData = (vasString) => {
    try {
      return JSON.parse(vasString.trim());
    } catch (error) {
      console.error('Error parsing VAS data:', error);
      return [];
    }
  };

  const getZonePricing = (pricingData, fromZone, toZone) => {
    if (!pricingData[fromZone] || !pricingData[fromZone][toZone]) {
      return '-';
    }
    return pricingData[fromZone][toZone];
  };

  const formatChargeValue = (charge) => {
    if (charge.charge_type === 'percent') {
      return `${charge.value}%`;
    } else if (charge.charge_type === 'per_kg') {
      return `₹${charge.value}/kg`;
    } else {
      return `₹${charge.value}`;
    }
  };

  const getPartnerLogo = (partner) => {
    const logos = {
      'delhivery': '/assets/images/Delhivery.png',
      'gati': '/assets/images/Gati.jpg',
      'movin': '/assets/images/movin.svg'
    };
    return logos[partner.toLowerCase()] || '/assets/images/delivary.png';
  };

  const handlePartnerClick = (partner) => {
    setExpandedPartner(expandedPartner === partner ? null : partner);
  };

  const toggleVasCharges = (partner) => {
    setShowVasCharges(prev => ({
      ...prev,
      [partner]: !prev[partner]
    }));
  };

  const toggleZoneInfo = () => {
    setShowZoneInfo(prev => ({
      ...prev,
      [activePartner]: !prev[activePartner]
    }));
  };

  const getZoneColor = (zone) => {
    const colors = {
      'N1': 'bg-blue-100 text-blue-800',
      'N2': 'bg-blue-200 text-blue-900',
      'N3': 'bg-indigo-100 text-indigo-800',
      'N4': 'bg-indigo-200 text-indigo-900',
      'C1': 'bg-purple-100 text-purple-800',
      'C2': 'bg-purple-200 text-purple-900',
      'W1': 'bg-pink-100 text-pink-800',
      'W2': 'bg-pink-200 text-pink-900',
      'S1': 'bg-red-100 text-red-800',
      'S2': 'bg-orange-100 text-orange-800',
      'S3': 'bg-amber-100 text-amber-800',
      'S4': 'bg-yellow-100 text-yellow-800',
      'E1': 'bg-green-100 text-green-800',
      'E2': 'bg-emerald-100 text-emerald-800',
      'NE1': 'bg-teal-100 text-teal-800',
      'NE2': 'bg-cyan-100 text-cyan-800'
    };
    return colors[zone] || 'bg-gray-100 text-gray-800';
  };

  return (
    <div className={`h-screen flex flex-col overflow-hidden ${isDarkMode ? 'dark:bg-darkmodeColor' : 'bg-white'}`}>
      <div className="z-10">
        <NavBar />
      </div>

      <div className="flex flex-1 overflow-hidden">
        {isToggleSidebar && (
          <div className={`fixed z-20 h-full w-64 md:relative duration-300 bg-gray-200 dark:bg-darkmodeColor dark:text-white md:bg-transparent mt-4 md:w-64 md:z-20`}
            style={
              window.innerWidth < 768
                ? { top: "113px", height: "calc(100vh - 115px)", overflowY: 'auto' }
                : {}
            }>
            <Sidebar />
          </div>
        )}

        <div className={`shadow-custom-light ml-3 mt-6 mb-6 mr-6 w-full rounded-custom custom-scrollbar overflow-y-auto dark:shadow-custom-dark ${isDarkMode ? 'dark:bg-darkmodeColor text-white' : 'bg-gradient-to-br from-gray-50 to-gray-100'}`}>
          <div className="p-4">
            {/* Header */}
            <button onClick={handleNavigation}
              className="text-xl w-full bg-customPurple sm:text-2xl font-bold mb-6 text-white font-sans px-4 py-3 rounded-xl shadow-xl flex items-center justify-center transition-all">
              <FcMoneyTransfer className="mr-2" size={28} />
              Rate Card Dashboard
            </button>

            {loading ? (
              <div className="flex items-center justify-center h-64">
                <div className="animate-spin rounded-full h-16 w-16 border-b-2 border-indigo-600"></div>
              </div>
            ) : data.length === 0 ? (
              <div className={`rounded-xl shadow-lg p-12 text-center ${isDarkMode ? 'dark:bg-darkmodeColor' : 'bg-white'}`}>
                <FcMoneyTransfer size={64} className="mx-auto mb-4 opacity-50" />
                <h3 className="text-xl font-semibold mb-2">No Rate Cards Available</h3>
                <p className={`${isDarkMode ? 'text-gray-400' : 'text-gray-500'}`}>
                  There are no courier partner rate cards to display at this time.
                </p>
              </div>
            ) : (
              <>
                {/* Tabs for Courier Partners */}
                <div className="flex space-x-12 mb-6 overflow-x-auto">
                  {data.slice(0, 3).map((item) => (
                    <button
                      key={item.id}
                      onClick={() => setActivePartner(item.partner)}
                      className={`flex-shrink-0 ml-12 rounded-custom shadow-xl p-2 transition-all ${activePartner === item.partner
                        ? 'bg-customPurple text-white'
                        : isDarkMode ? 'bg-gray-700 text-gray-300' : 'bg-gray-200 text-gray-700'
                        }`}
                    >
                      <span className="w-72 h-8 flex items-center justify-center text-lg font-semibold">
                        {item.partner}
                      </span>
                    </button>
                  ))}
                </div>

                {/* Zone Metrics Section */}
                {Object.keys(zoneMetrics).length > 0 && (
                  <div className={`border-2 ${isDarkMode ? 'border-gray-600' : 'border-gray-200'} rounded-lg overflow-hidden mb-6`}>
                    <button
                      onClick={toggleZoneInfo}
                      className="w-full p-4 flex items-center justify-between bg-customPurple transition-all text-white"
                    >
                      <span className="font-semibold flex items-center gap-2 text-lg">
                        <span className="text-2xl">🗺️</span>
                        Zone Information & Coverage Areas
                      </span>
                      <svg
                        className={`w-6 h-6 transition-transform duration-300 ${showZoneInfo[activePartner] ? 'rotate-180' : ''}`}
                        fill="none"
                        stroke="currentColor"
                        viewBox="0 0 24 24"
                      >
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
                      </svg>
                    </button>

                    {showZoneInfo[activePartner] && (
                      <div className={`p-4 ${isDarkMode ? 'dark:bg-darkmodeColor' : 'bg-white'}`}>
                        <div className="overflow-x-auto">
                          <table className={`min-w-full ${isDarkMode ? 'dark:bg-darkmodeColor' : 'bg-white'} rounded-lg overflow-hidden`}>
                            <thead className="bg-gradient-to-r from-indigo-600 to-purple-600 text-white">
                              <tr>
                                <th className="px-4 py-3 text-left text-sm font-semibold">Zone</th>
                                <th className="px-4 py-3 text-left text-sm font-semibold">Coverage Areas</th>
                                <th className="px-4 py-3 text-left text-sm font-semibold">Total Locations</th>
                              </tr>
                            </thead>
                            <tbody>
                              {Object.entries(zoneMetrics).map(([zone, locations], idx) => (
                                <tr
                                  key={zone}
                                  className={`${idx % 2 === 0
                                    ? isDarkMode ? 'dark:bg-darkmodeColor' : 'bg-white'
                                    : isDarkMode ? 'dark:bg-darkmodeColor' : 'bg-gray-50'
                                    } transition-colors`}
                                >
                                  <td className={`px-4 py-3 border-b ${isDarkMode ? 'border-gray-700' : 'border-gray-200'}`}>
                                    <span className={`px-3 py-1 rounded-full font-bold text-sm ${getZoneColor(zone)}`}>
                                      {zone}
                                    </span>
                                  </td>
                                  <td className={`px-4 py-3 border-b ${isDarkMode ? 'border-gray-700' : 'border-gray-200'}`}>
                                    <div className="flex flex-wrap gap-2">
                                      {locations.map((location, locIdx) => (
                                        <span
                                          key={locIdx}
                                          className={`px-2 py-1 rounded text-xs ${
                                            isDarkMode ? 'bg-gray-700 text-gray-200' : 'bg-gray-100 text-gray-700'
                                          }`}
                                        >
                                          {location}
                                        </span>
                                      ))}
                                    </div>
                                  </td>
                                  <td className={`px-4 py-3 border-b ${isDarkMode ? 'border-gray-700' : 'border-gray-200'} text-center font-semibold`}>
                                    {locations.length}
                                  </td>
                                </tr>
                              ))}
                            </tbody>
                          </table>
                        </div>
                      </div>
                    )}

                  </div>
                )}

                {/* Content for Active Partner */}
                {(() => {
                  const activeItem = data.find(item => item.partner === activePartner);
                  if (!activeItem) return null;
                  const pricingData = parsePricingData(activeItem.zone_pricing);
                  const vasCharges = parseVasData(activeItem.vas_pricing);
                  const activeCharges = vasCharges.filter(charge => charge.is_active);
                  const zones = Object.keys(pricingData);

                  return (
                    <div className={`${isDarkMode ? 'dark:bg-darkmodeColor' : 'bg-white'} rounded-xl shadow-lg overflow-hidden`}>
                      {/* Partner Header */}
                      <div className="p-6 flex items-center justify-between text-white">
                        <div className="flex items-center gap-4">
                          <div className="bg-white p-2 rounded-lg shadow-md">
                            <img
                              src={getPartnerLogo(activeItem.partner)}
                              alt={`${activeItem.partner} logo`}
                              className="w-12 h-12 object-contain"
                            />
                          </div>
                          <div className="text-left">
                            <h2 className="text-2xl font-bold capitalize">{activeItem.partner}</h2>
                            <p className="text-sm opacity-90">{zones.length} zones available</p>
                          </div>
                        </div>
                      </div>

                      {/* Content */}
                      <div className="p-6 space-y-6">
                        {/* VAS Charges Section */}
                        {activeCharges.length > 0 && (
                          <div className={`border-2 ${isDarkMode ? 'border-gray-600' : 'border-gray-200'} rounded-lg overflow-hidden`}>
                            <button
                              onClick={() => toggleVasCharges(activeItem.partner)}
                              className="w-full p-4 flex items-center justify-between bg-customPurple transition-all text-white"
                            >
                              <span className="font-semibold flex items-center gap-2">
                                <span className="text-xl">💰</span>
                                VAS Charges (Value Added Services)
                              </span>
                              <svg
                                className={`w-5 h-5 transition-transform duration-300 ${showVasCharges[activeItem.partner] ? 'rotate-180' : ''}`}
                                fill="none"
                                stroke="currentColor"
                                viewBox="0 0 24 24"
                              >
                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
                              </svg>
                            </button>

                            {showVasCharges[activeItem.partner] && (
                              <div className={`p-4 ${isDarkMode ? 'dark:bg-darkmodeColor' : 'dark:bg-darkmodeColor'}`}>
                                <div className="overflow-x-auto">
                                  <table className={`min-w-full ${isDarkMode ? 'dark:bg-darkmodeColor' : 'bg-white'} rounded-lg overflow-hidden`}>
                                    <thead className="bg-gradient-to-r from-indigo-600 to-purple-600 text-white">
                                      <tr>
                                        <th className="px-4 py-3 text-left text-sm font-semibold">Charge Key</th>
                                        <th className="px-4 py-3 text-left text-sm font-semibold">Label</th>
                                        <th className="px-4 py-3 text-left text-sm font-semibold">Type</th>
                                        <th className="px-4 py-3 text-left text-sm font-semibold">Condition</th>
                                        <th className="px-4 py-3 text-left text-sm font-semibold">Value</th>
                                        <th className="px-4 py-3 text-left text-sm font-semibold">Min Value</th>
                                        <th className="px-4 py-3 text-left text-sm font-semibold">Max Value</th>
                                      </tr>
                                    </thead>
                                    <tbody>
                                      {activeCharges.map((charge, idx) => (
                                        <tr
                                          key={idx}
                                          className={`${idx % 2 === 0
                                            ? isDarkMode ? 'dark:bg-darkmodeColor' : 'bg-white'
                                            : isDarkMode ? 'dark:bg-darkmodeColor' : 'bg-gray-50'
                                            }  transition-colors`}
                                        >
                                          <td className={`px-4 py-3 border-b ${isDarkMode ? 'border-gray-700' : 'border-gray-200'} font-mono text-sm text-indigo-600 dark:text-indigo-400 font-semibold`}>
                                            {charge.charge_key}
                                          </td>
                                          <td className={`px-4 py-3 border-b ${isDarkMode ? 'border-gray-700' : 'border-gray-200'} font-medium`}>
                                            {charge.label}
                                          </td>
                                          <td className={`px-4 py-3 border-b ${isDarkMode ? 'border-gray-700' : 'border-gray-200'}`}>
                                            <span className={`px-3 py-1 rounded-full text-xs font-semibold ${isDarkMode ? 'bg-gray-700 text-gray-300' : 'bg-gray-200 text-gray-700'}`}>
                                              {charge.charge_type}
                                            </span>
                                          </td>
                                          <td className={`px-4 py-3 border-b ${isDarkMode ? 'border-gray-700' : 'border-gray-200'} text-sm`}>
                                            {charge.condition_value || '-'}
                                          </td>
                                          <td className={`px-4 py-3 border-b ${isDarkMode ? 'border-gray-700' : 'border-gray-200'} font-bold text-indigo-600 dark:text-indigo-400`}>
                                            {formatChargeValue(charge)}
                                          </td>
                                          <td className={`px-4 py-3 border-b ${isDarkMode ? 'border-gray-700' : 'border-gray-200'} text-sm`}>
                                            {charge.min_value ? `₹${charge.min_value}` : '-'}
                                          </td>
                                          <td className={`px-4 py-3 border-b ${isDarkMode ? 'border-gray-700' : 'border-gray-200'} text-sm`}>
                                            {charge.max_value ? `₹${charge.max_value}` : '-'}
                                          </td>
                                        </tr>
                                      ))}
                                    </tbody>
                                  </table>
                                </div>
                              </div>
                            )}
                          </div>
                        )}

                        {/* Zone Pricing Table */}
                        <div className={`border-2 ${isDarkMode ? 'border-gray-600' : 'border-gray-200'} rounded-lg overflow-hidden`}>
                          <div className="p-4 bg-customPurple text-white">
                            <h3 className="font-semibold text-lg">Zone Pricing Matrix</h3>
                          </div>
                          <div className="overflow-x-auto">
                            <table className="min-w-full">
                              <thead className={`${isDarkMode ? 'dark:bg-darkmodeColor' : 'bg-gray-100'}`}>
                                <tr>
                                  <th className={`px-4 py-3 text-left font-semibold border-b-2 ${isDarkMode ? 'border-gray-600 text-gray-300' : 'border-gray-300 text-gray-700'}`}>Zone</th>
                                  <th className={`px-4 py-3 text-left font-semibold border-b-2 ${isDarkMode ? 'border-gray-600 text-gray-300' : 'border-gray-300 text-gray-700'}`}>To North (N1-N4)</th>
                                  <th className={`px-4 py-3 text-left font-semibold border-b-2 ${isDarkMode ? 'border-gray-600 text-gray-300' : 'border-gray-300 text-gray-700'}`}>To Central (C1-C2)</th>
                                  <th className={`px-4 py-3 text-left font-semibold border-b-2 ${isDarkMode ? 'border-gray-600 text-gray-300' : 'border-gray-300 text-gray-700'}`}>To West (W1-W2)</th>
                                  <th className={`px-4 py-3 text-left font-semibold border-b-2 ${isDarkMode ? 'border-gray-600 text-gray-300' : 'border-gray-300 text-gray-700'}`}>To South (S1-S4)</th>
                                  <th className={`px-4 py-3 text-left font-semibold border-b-2 ${isDarkMode ? 'border-gray-600 text-gray-300' : 'border-gray-300 text-gray-700'}`}>To East (E1-E2)</th>
                                  <th className={`px-4 py-3 text-left font-semibold border-b-2 ${isDarkMode ? 'border-gray-600 text-gray-300' : 'border-gray-300 text-gray-700'}`}>To Northeast (NE1-NE2)</th>
                                </tr>
                              </thead>
                              <tbody>
                                {zones.map((zone, zoneIndex) => (
                                  <tr
                                    key={zone}
                                    className={`${zoneIndex % 2 === 0
                                      ? isDarkMode ? 'dark:bg-darkmodeColor' : 'bg-white'
                                      : isDarkMode ? 'dark:bg-darkmodeColor' : 'bg-gray-50'
                                      } hover:bg-indigo-50 dark:hover:bg-indigo-900 transition-colors`}
                                  >
                                    <td className={`px-4 py-3 border-b ${isDarkMode ? 'border-gray-700' : 'border-gray-200'}`}>
                                      <span className="font-bold text-lg text-customPurple dark:text-customPurple">
                                        {zoneMapping[zone] || zone.toUpperCase()}
                                      </span>
                                    </td>
                                    <td className={`px-4 py-3 border-b ${isDarkMode ? 'border-gray-700' : 'border-gray-200'}`}>
                                      <div className="grid grid-cols-2 gap-2 text-sm">
                                        {['n1', 'n2', 'n3', 'n4'].map(z => (
                                          <div key={z} className="flex items-center gap-1">
                                            <span className={`font-medium ${isDarkMode ? 'text-gray-400' : 'text-gray-600'}`}>{z.toUpperCase()}:</span>
                                            <span className="font-semibold">₹{getZonePricing(pricingData, zone, z)}</span>
                                          </div>
                                        ))}
                                      </div>
                                    </td>
                                    <td className={`px-4 py-3 border-b ${isDarkMode ? 'border-gray-700' : 'border-gray-200'}`}>
                                      <div className="grid grid-cols-1 gap-2 text-sm">
                                        {['c1', 'c2'].map(z => (
                                          <div key={z} className="flex items-center gap-1">
                                            <span className={`font-medium ${isDarkMode ? 'text-gray-400' : 'text-gray-600'}`}>{z.toUpperCase()}:</span>
                                            <span className="font-semibold">₹{getZonePricing(pricingData, zone, z)}</span>
                                          </div>
                                        ))}
                                      </div>
                                    </td>
                                    <td className={`px-4 py-3 border-b ${isDarkMode ? 'border-gray-700' : 'border-gray-200'}`}>
                                      <div className="grid grid-cols-1 gap-2 text-sm">
                                        {['w1', 'w2'].map(z => (
                                          <div key={z} className="flex items-center gap-1">
                                            <span className={`font-medium ${isDarkMode ? 'text-gray-400' : 'text-gray-600'}`}>{z.toUpperCase()}:</span>
                                            <span className="font-semibold">₹{getZonePricing(pricingData, zone, z)}</span>
                                          </div>
                                        ))}
                                      </div>
                                    </td>
                                    <td className={`px-4 py-3 border-b ${isDarkMode ? 'border-gray-700' : 'border-gray-200'}`}>
                                      <div className="grid grid-cols-2 gap-2 text-sm">
                                        {['s1', 's2', 's3', 's4'].map(z => (
                                          <div key={z} className="flex items-center gap-1">
                                            <span className={`font-medium ${isDarkMode ? 'text-gray-400' : 'text-gray-600'}`}>{z.toUpperCase()}:</span>
                                            <span className="font-semibold">₹{getZonePricing(pricingData, zone, z)}</span>
                                          </div>
                                        ))}
                                      </div>
                                    </td>
                                    <td className={`px-4 py-3 border-b ${isDarkMode ? 'border-gray-700' : 'border-gray-200'}`}>
                                      <div className="grid grid-cols-1 gap-2 text-sm">
                                        {['e1', 'e2'].map(z => (
                                          <div key={z} className="flex items-center gap-1">
                                            <span className={`font-medium ${isDarkMode ? 'text-gray-400' : 'text-gray-600'}`}>{z.toUpperCase()}:</span>
                                            <span className="font-semibold">₹{getZonePricing(pricingData, zone, z)}</span>
                                          </div>
                                        ))}
                                      </div>
                                    </td>
                                    <td className={`px-4 py-3 border-b ${isDarkMode ? 'border-gray-700' : 'border-gray-200'}`}>
                                      <div className="grid grid-cols-1 gap-2 text-sm">
                                        {['ne1', 'ne2'].map(z => (
                                          <div key={z} className="flex items-center gap-1">
                                            <span className={`font-medium ${isDarkMode ? 'text-gray-400' : 'text-gray-600'}`}>{z.toUpperCase()}:</span>
                                            <span className="font-semibold">₹{getZonePricing(pricingData, zone, z)}</span>
                                          </div>
                                        ))}
                                      </div>
                                    </td>
                                  </tr>
                                ))}
                              </tbody>
                            </table>
                          </div>
                        </div>
                      </div>
                    </div>
                  );
                })()}
              </>
            )}
          </div>
        </div>
      </div>
    </div>
    // <div className={`h-screen flex flex-col overflow-hidden ${isDarkMode ? 'dark:bg-darkmodeColor' : 'bg-white'}`}>
    //   <div className="z-10">
    //     <NavBar />
    //   </div>

    //   <div className="flex flex-1 overflow-hidden">
    //     {isToggleSidebar && (
    //       <div className={`fixed z-20 h-full w-64 md:relative duration-300 bg-gray-200 dark:bg-darkmodeColor dark:text-white md:bg-transparent mt-4 md:w-64 md:z-20`}
    //         style={
    //           window.innerWidth < 768
    //             ? { top: "113px", height: "calc(100vh - 115px)", overflowY: 'auto' }
    //             : {}
    //         }>
    //         <Sidebar />
    //       </div>
    //     )}

    //     <div className={`shadow-custom-light ml-3 mt-6 mb-6 mr-6 w-full rounded-custom custom-scrollbar overflow-y-auto dark:shadow-custom-dark ${isDarkMode ? 'dark:bg-darkmodeColor text-white' : 'bg-gradient-to-br from-gray-50 to-gray-100'}`}>
    //       <div className="p-4">
    //         {/* Header */}
    //         <button onClick={handleNavigation}
    //           className="text-xl w-full bg-gradient-to-r from-indigo-600 to-purple-600 hover:from-indigo-700 hover:to-purple-700 sm:text-2xl font-bold mb-8 text-white font-sans px-6 py-4 rounded-2xl shadow-2xl flex items-center justify-center transition-all transform hover:scale-[1.02] duration-300">
    //           <FcMoneyTransfer className="mr-3" size={32} />
    //           Rate Card Dashboard
    //         </button>

    //         {loading ? (
    //           <div className="flex items-center justify-center h-64">
    //             <div className="animate-spin rounded-full h-16 w-16 border-b-2 border-indigo-600"></div>
    //           </div>
    //         ) : data.length === 0 ? (
    //           <div className={`rounded-2xl shadow-xl p-12 text-center backdrop-blur-sm ${isDarkMode ? 'dark:bg-darkmodeColor border border-gray-700' : 'bg-white border border-gray-100'}`}>
    //             <FcMoneyTransfer size={64} className="mx-auto mb-4 opacity-50" />
    //             <h3 className="text-xl font-semibold mb-2">No Rate Cards Available</h3>
    //             <p className={`${isDarkMode ? 'text-gray-400' : 'text-gray-500'}`}>
    //               There are no courier partner rate cards to display at this time.
    //             </p>
    //           </div>
    //         ) : (
    //           <>
    //             {/* Tabs for Courier Partners - Small by default, expand on active */}
    //             <div className="flex gap-3 mb-8 overflow-x-auto pb-2 scrollbar-thin">
    //               {data.slice(0, 3).map((item) => (
    //                 <button
    //                   key={item.id}
    //                   onClick={() => setActivePartner(item.partner)}
    //                   className={`flex-shrink-0 rounded-lg font-semibold transition-all duration-300 transform hover:scale-105 shadow-md ${activePartner === item.partner
    //                       ? 'px-8 py-3 text-base bg-gradient-to-r from-indigo-600 to-purple-600 text-white shadow-lg scale-105'
    //                       : 'px-4 py-2 text-xs bg-white text-gray-700 hover:bg-gray-50 border border-gray-200'
    //                     } ${isDarkMode && activePartner !== item.partner ? 'bg-gray-700 text-gray-300 hover:bg-gray-600 border-gray-600' : ''}`}
    //                 >
    //                   <span className="whitespace-nowrap">
    //                     {item.partner}
    //                   </span>
    //                 </button>
    //               ))}
    //             </div>

    //             {/* Zone Metrics Section */}
    //             {Object.keys(zoneMetrics).length > 0 && (
    //               <div className={`border ${isDarkMode ? 'border-gray-700 bg-gray-800/50' : 'border-gray-200 bg-white'} rounded-2xl overflow-hidden mb-6 shadow-lg backdrop-blur-sm`}>
    //                 <button
    //                   onClick={toggleZoneInfo}
    //                   className="w-full p-5 flex items-center justify-between bg-gradient-to-r from-indigo-600 to-purple-600 hover:from-indigo-700 hover:to-purple-700 transition-all text-white"
    //                 >
    //                   <span className="font-semibold flex items-center gap-3 text-lg">
    //                     <span className="text-2xl">🗺️</span>
    //                     Zone Information & Coverage Areas
    //                   </span>
    //                   <svg
    //                     className={`w-6 h-6 transition-transform duration-300 ${showZoneInfo[activePartner] ? 'rotate-180' : ''}`}
    //                     fill="none"
    //                     stroke="currentColor"
    //                     viewBox="0 0 24 24"
    //                   >
    //                     <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
    //                   </svg>
    //                 </button>

    //                 {showZoneInfo[activePartner] && (
    //                   <div className={`p-6 ${isDarkMode ? 'dark:bg-darkmodeColor' : 'bg-gradient-to-br from-gray-50 to-white'}`}>
    //                     <div className="overflow-x-auto rounded-xl border ${isDarkMode ? 'border-gray-700' : 'border-gray-200'}">
    //                       <table className={`min-w-full ${isDarkMode ? 'dark:bg-darkmodeColor' : 'bg-white'}`}>
    //                         <thead className="bg-gradient-to-r from-indigo-600 to-purple-600 text-white">
    //                           <tr>
    //                             <th className="px-6 py-4 text-left text-sm font-semibold">Zone</th>
    //                             <th className="px-6 py-4 text-left text-sm font-semibold">Coverage Areas</th>
    //                             <th className="px-6 py-4 text-left text-sm font-semibold">Total Locations</th>
    //                           </tr>
    //                         </thead>
    //                         <tbody>
    //                           {Object.entries(zoneMetrics).map(([zone, locations], idx) => (
    //                             <tr
    //                               key={zone}
    //                               className={`${idx % 2 === 0
    //                                 ? isDarkMode ? 'dark:bg-darkmodeColor' : 'bg-white'
    //                                 : isDarkMode ? 'bg-gray-800/30' : 'bg-gray-50'
    //                                 } hover:bg-indigo-50/50 dark:hover:bg-indigo-900/20 transition-colors`}
    //                             >
    //                               <td className={`px-6 py-4 border-b ${isDarkMode ? 'border-gray-700' : 'border-gray-200'}`}>
    //                                 <span className={`px-4 py-1.5 rounded-full font-bold text-sm ${getZoneColor(zone)} shadow-sm`}>
    //                                   {zone}
    //                                 </span>
    //                               </td>
    //                               <td className={`px-6 py-4 border-b ${isDarkMode ? 'border-gray-700' : 'border-gray-200'}`}>
    //                                 <div className="flex flex-wrap gap-2">
    //                                   {locations.map((location, locIdx) => (
    //                                     <span
    //                                       key={locIdx}
    //                                       className={`px-3 py-1 rounded-lg text-xs font-medium ${isDarkMode ? 'bg-gray-700 text-gray-200' : 'bg-gradient-to-r from-gray-100 to-gray-200 text-gray-700'
    //                                         } shadow-sm`}
    //                                     >
    //                                       {location}
    //                                     </span>
    //                                   ))}
    //                                 </div>
    //                               </td>
    //                               <td className={`px-6 py-4 border-b ${isDarkMode ? 'border-gray-700' : 'border-gray-200'} text-center`}>
    //                                 <span className="inline-flex items-center justify-center w-10 h-10 rounded-full bg-gradient-to-r from-indigo-600 to-purple-600 text-white font-bold text-sm shadow-md">
    //                                   {locations.length}
    //                                 </span>
    //                               </td>
    //                             </tr>
    //                           ))}
    //                         </tbody>
    //                       </table>
    //                     </div>
    //                   </div>
    //                 )}
    //               </div>
    //             )}

    //             {/* Content for Active Partner */}
    //             {(() => {
    //               const activeItem = data.find(item => item.partner === activePartner);
    //               if (!activeItem) return null;
    //               const pricingData = parsePricingData(activeItem.zone_pricing);
    //               const vasCharges = parseVasData(activeItem.vas_pricing);
    //               const activeCharges = vasCharges.filter(charge => charge.is_active);
    //               const zones = Object.keys(pricingData);

    //               return (
    //                 <div className={`${isDarkMode ? 'dark:bg-darkmodeColor border border-gray-700' : 'bg-white border border-gray-100'} rounded-2xl shadow-xl overflow-hidden backdrop-blur-sm`}>
    //                   {/* Partner Header */}
    //                   <div className="p-6 bg-gradient-to-r from-indigo-600 to-purple-600">
    //                     <div className="flex items-center gap-4">
    //                       <div className="bg-white p-3 rounded-xl shadow-lg transform hover:scale-110 transition-transform duration-300">
    //                         <img
    //                           src={getPartnerLogo(activeItem.partner)}
    //                           alt={`${activeItem.partner} logo`}
    //                           className="w-14 h-14 object-contain"
    //                         />
    //                       </div>
    //                       <div className="text-left">
    //                         <h2 className="text-3xl font-bold capitalize text-white drop-shadow-lg">{activeItem.partner}</h2>
    //                         <p className="text-sm text-indigo-100 font-medium mt-1">{zones.length} zones available</p>
    //                       </div>
    //                     </div>
    //                   </div>

    //                   {/* Content */}
    //                   <div className="p-6 space-y-6">
    //                     {/* VAS Charges Section */}
    //                     {activeCharges.length > 0 && (
    //                       <div className={`border ${isDarkMode ? 'border-gray-700 bg-gray-800/50' : 'border-gray-200 bg-gradient-to-br from-white to-gray-50'} rounded-xl overflow-hidden shadow-lg`}>
    //                         <button
    //                           onClick={() => toggleVasCharges(activeItem.partner)}
    //                           className="w-full p-5 flex items-center justify-between bg-gradient-to-r from-indigo-600 to-purple-600 hover:from-indigo-700 hover:to-purple-700 transition-all text-white"
    //                         >
    //                           <span className="font-semibold flex items-center gap-3 text-lg">
    //                             <span className="text-2xl">💰</span>
    //                             VAS Charges (Value Added Services)
    //                           </span>
    //                           <svg
    //                             className={`w-6 h-6 transition-transform duration-300 ${showVasCharges[activeItem.partner] ? 'rotate-180' : ''}`}
    //                             fill="none"
    //                             stroke="currentColor"
    //                             viewBox="0 0 24 24"
    //                           >
    //                             <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
    //                           </svg>
    //                         </button>

    //                         {showVasCharges[activeItem.partner] && (
    //                           <div className={`p-6 ${isDarkMode ? 'dark:bg-darkmodeColor' : 'bg-white'}`}>
    //                             <div className="overflow-x-auto rounded-xl border ${isDarkMode ? 'border-gray-700' : 'border-gray-200'}">
    //                               <table className={`min-w-full ${isDarkMode ? 'dark:bg-darkmodeColor' : 'bg-white'}`}>
    //                                 <thead className="bg-gradient-to-r from-indigo-600 to-purple-600 text-white">
    //                                   <tr>
    //                                     <th className="px-6 py-4 text-left text-sm font-semibold">Charge Key</th>
    //                                     <th className="px-6 py-4 text-left text-sm font-semibold">Label</th>
    //                                     <th className="px-6 py-4 text-left text-sm font-semibold">Type</th>
    //                                     <th className="px-6 py-4 text-left text-sm font-semibold">Condition</th>
    //                                     <th className="px-6 py-4 text-left text-sm font-semibold">Value</th>
    //                                     <th className="px-6 py-4 text-left text-sm font-semibold">Min Value</th>
    //                                     <th className="px-6 py-4 text-left text-sm font-semibold">Max Value</th>
    //                                   </tr>
    //                                 </thead>
    //                                 <tbody>
    //                                   {activeCharges.map((charge, idx) => (
    //                                     <tr
    //                                       key={idx}
    //                                       className={`${idx % 2 === 0
    //                                         ? isDarkMode ? 'dark:bg-darkmodeColor' : 'bg-white'
    //                                         : isDarkMode ? 'bg-gray-800/30' : 'bg-gray-50'
    //                                         } hover:bg-indigo-50/50 dark:hover:bg-indigo-900/20 transition-colors`}
    //                                     >
    //                                       <td className={`px-6 py-4 border-b ${isDarkMode ? 'border-gray-700' : 'border-gray-200'} font-mono text-sm text-indigo-600 dark:text-indigo-400 font-semibold`}>
    //                                         {charge.charge_key}
    //                                       </td>
    //                                       <td className={`px-6 py-4 border-b ${isDarkMode ? 'border-gray-700' : 'border-gray-200'} font-medium`}>
    //                                         {charge.label}
    //                                       </td>
    //                                       <td className={`px-6 py-4 border-b ${isDarkMode ? 'border-gray-700' : 'border-gray-200'}`}>
    //                                         <span className={`px-4 py-1.5 rounded-full text-xs font-semibold shadow-sm ${isDarkMode ? 'bg-gray-700 text-gray-300' : 'bg-gradient-to-r from-gray-100 to-gray-200 text-gray-700'}`}>
    //                                           {charge.charge_type}
    //                                         </span>
    //                                       </td>
    //                                       <td className={`px-6 py-4 border-b ${isDarkMode ? 'border-gray-700' : 'border-gray-200'} text-sm`}>
    //                                         {charge.condition_value || '-'}
    //                                       </td>
    //                                       <td className={`px-6 py-4 border-b ${isDarkMode ? 'border-gray-700' : 'border-gray-200'} font-bold text-indigo-600 dark:text-indigo-400 text-base`}>
    //                                         {formatChargeValue(charge)}
    //                                       </td>
    //                                       <td className={`px-6 py-4 border-b ${isDarkMode ? 'border-gray-700' : 'border-gray-200'} text-sm`}>
    //                                         {charge.min_value ? `₹${charge.min_value}` : '-'}
    //                                       </td>
    //                                       <td className={`px-6 py-4 border-b ${isDarkMode ? 'border-gray-700' : 'border-gray-200'} text-sm`}>
    //                                         {charge.max_value ? `₹${charge.max_value}` : '-'}
    //                                       </td>
    //                                     </tr>
    //                                   ))}
    //                                 </tbody>
    //                               </table>
    //                             </div>
    //                           </div>
    //                         )}
    //                       </div>
    //                     )}

    //                     {/* Zone Pricing Table */}
    //                     <div className={`border ${isDarkMode ? 'border-gray-700 bg-gray-800/50' : 'border-gray-200 bg-gradient-to-br from-white to-gray-50'} rounded-xl overflow-hidden shadow-lg`}>
    //                       <div className="p-5 bg-gradient-to-r from-indigo-600 to-purple-600 text-white">
    //                         <h3 className="font-semibold text-lg flex items-center gap-2">
    //                           <span className="text-xl">📊</span>
    //                           Zone Pricing Matrix
    //                         </h3>
    //                       </div>
    //                       <div className="overflow-x-auto">
    //                         <table className="min-w-full">
    //                           <thead className={`${isDarkMode ? 'bg-gray-800' : 'bg-gradient-to-r from-gray-50 to-gray-100'}`}>
    //                             <tr>
    //                               <th className={`px-6 py-4 text-left font-semibold border-b-2 ${isDarkMode ? 'border-gray-600 text-gray-300' : 'border-indigo-200 text-gray-700'} text-sm`}>Zone</th>
    //                               <th className={`px-6 py-4 text-left font-semibold border-b-2 ${isDarkMode ? 'border-gray-600 text-gray-300' : 'border-indigo-200 text-gray-700'} text-sm`}>To North (N1-N4)</th>
    //                               <th className={`px-6 py-4 text-left font-semibold border-b-2 ${isDarkMode ? 'border-gray-600 text-gray-300' : 'border-indigo-200 text-gray-700'} text-sm`}>To Central (C1-C2)</th>
    //                               <th className={`px-6 py-4 text-left font-semibold border-b-2 ${isDarkMode ? 'border-gray-600 text-gray-300' : 'border-indigo-200 text-gray-700'} text-sm`}>To West (W1-W2)</th>
    //                               <th className={`px-6 py-4 text-left font-semibold border-b-2 ${isDarkMode ? 'border-gray-600 text-gray-300' : 'border-indigo-200 text-gray-700'} text-sm`}>To South (S1-S4)</th>
    //                               <th className={`px-6 py-4 text-left font-semibold border-b-2 ${isDarkMode ? 'border-gray-600 text-gray-300' : 'border-indigo-200 text-gray-700'} text-sm`}>To East (E1-E2)</th>
    //                               <th className={`px-6 py-4 text-left font-semibold border-b-2 ${isDarkMode ? 'border-gray-600 text-gray-300' : 'border-indigo-200 text-gray-700'} text-sm`}>To Northeast (NE1-NE2)</th>
    //                             </tr>
    //                           </thead>
    //                           <tbody>
    //                             {zones.map((zone, zoneIndex) => (
    //                               <tr
    //                                 key={zone}
    //                                 className={`${zoneIndex % 2 === 0
    //                                   ? isDarkMode ? 'dark:bg-darkmodeColor' : 'bg-white'
    //                                   : isDarkMode ? 'bg-gray-800/30' : 'bg-gray-50'
    //                                   } hover:bg-indigo-50 dark:hover:bg-indigo-900/20 transition-all duration-200`}
    //                               >
    //                                 <td className={`px-6 py-4 border-b ${isDarkMode ? 'border-gray-700' : 'border-gray-200'}`}>
    //                                   <span className="inline-flex items-center justify-center px-4 py-2 rounded-lg font-bold text-base bg-gradient-to-r from-indigo-600 to-purple-600 text-white shadow-md">
    //                                     {zoneMapping[zone] || zone.toUpperCase()}
    //                                   </span>
    //                                 </td>
    //                                 <td className={`px-6 py-4 border-b ${isDarkMode ? 'border-gray-700' : 'border-gray-200'}`}>
    //                                   <div className="grid grid-cols-2 gap-2 text-sm">
    //                                     {['n1', 'n2', 'n3', 'n4'].map(z => (
    //                                       <div key={z} className={`flex items-center gap-1 px-2 py-1 rounded-md ${isDarkMode ? 'bg-gray-800' : 'bg-gray-100'}`}>
    //                                         <span className={`font-medium ${isDarkMode ? 'text-gray-400' : 'text-gray-600'}`}>{z.toUpperCase()}:</span>
    //                                         <span className="font-bold text-indigo-600 dark:text-indigo-400">₹{getZonePricing(pricingData, zone, z)}</span>
    //                                       </div>
    //                                     ))}
    //                                   </div>
    //                                 </td>
    //                                 <td className={`px-6 py-4 border-b ${isDarkMode ? 'border-gray-700' : 'border-gray-200'}`}>
    //                                   <div className="grid grid-cols-1 gap-2 text-sm">
    //                                     {['c1', 'c2'].map(z => (
    //                                       <div key={z} className={`flex items-center gap-1 px-2 py-1 rounded-md ${isDarkMode ? 'bg-gray-800' : 'bg-gray-100'}`}>
    //                                         <span className={`font-medium ${isDarkMode ? 'text-gray-400' : 'text-gray-600'}`}>{z.toUpperCase()}:</span>
    //                                         <span className="font-bold text-indigo-600 dark:text-indigo-400">₹{getZonePricing(pricingData, zone, z)}</span>
    //                                       </div>
    //                                     ))}
    //                                   </div>
    //                                 </td>
    //                                 <td className={`px-6 py-4 border-b ${isDarkMode ? 'border-gray-700' : 'border-gray-200'}`}>
    //                                   <div className="grid grid-cols-1 gap-2 text-sm">
    //                                     {['w1', 'w2'].map(z => (
    //                                       <div key={z} className={`flex items-center gap-1 px-2 py-1 rounded-md ${isDarkMode ? 'bg-gray-800' : 'bg-gray-100'}`}>
    //                                         <span className={`font-medium ${isDarkMode ? 'text-gray-400' : 'text-gray-600'}`}>{z.toUpperCase()}:</span>
    //                                         <span className="font-bold text-indigo-600 dark:text-indigo-400">₹{getZonePricing(pricingData, zone, z)}</span>
    //                                       </div>
    //                                     ))}
    //                                   </div>
    //                                 </td>
    //                                 <td className={`px-6 py-4 border-b ${isDarkMode ? 'border-gray-700' : 'border-gray-200'}`}>
    //                                   <div className="grid grid-cols-2 gap-2 text-sm">
    //                                     {['s1', 's2', 's3', 's4'].map(z => (
    //                                       <div key={z} className={`flex items-center gap-1 px-2 py-1 rounded-md ${isDarkMode ? 'bg-gray-800' : 'bg-gray-100'}`}>
    //                                         <span className={`font-medium ${isDarkMode ? 'text-gray-400' : 'text-gray-600'}`}>{z.toUpperCase()}:</span>
    //                                         <span className="font-bold text-indigo-600 dark:text-indigo-400">₹{getZonePricing(pricingData, zone, z)}</span>
    //                                       </div>
    //                                     ))}
    //                                   </div>
    //                                 </td>
    //                                 <td className={`px-6 py-4 border-b ${isDarkMode ? 'border-gray-700' : 'border-gray-200'}`}>
    //                                   <div className="grid grid-cols-1 gap-2 text-sm">
    //                                     {['e1', 'e2'].map(z => (
    //                                       <div key={z} className={`flex items-center gap-1 px-2 py-1 rounded-md ${isDarkMode ? 'bg-gray-800' : 'bg-gray-100'}`}>
    //                                         <span className={`font-medium ${isDarkMode ? 'text-gray-400' : 'text-gray-600'}`}>{z.toUpperCase()}:</span>
    //                                         <span className="font-bold text-indigo-600 dark:text-indigo-400">₹{getZonePricing(pricingData, zone, z)}</span>
    //                                       </div>
    //                                     ))}
    //                                   </div>
    //                                 </td>
    //                                 <td className={`px-6 py-4 border-b ${isDarkMode ? 'border-gray-700' : 'border-gray-200'}`}>
    //                                   <div className="grid grid-cols-1 gap-2 text-sm">
    //                                     {['ne1', 'ne2'].map(z => (
    //                                       <div key={z} className={`flex items-center gap-1 px-2 py-1 rounded-md ${isDarkMode ? 'bg-gray-800' : 'bg-gray-100'}`}>
    //                                         <span className={`font-medium ${isDarkMode ? 'text-gray-400' : 'text-gray-600'}`}>{z.toUpperCase()}:</span>
    //                                         <span className="font-bold text-indigo-600 dark:text-indigo-400">₹{getZonePricing(pricingData, zone, z)}</span>
    //                                       </div>
    //                                     ))}
    //                                   </div>
    //                                 </td>
    //                               </tr>
    //                             ))}
    //                           </tbody>
    //                         </table>
    //                       </div>
    //                     </div>
    //                   </div>
    //                 </div>
    //               );
    //             })()}
    //           </>
    //         )}
    //       </div>
    //     </div>
    //   </div>
    // </div>
  );

};

export default B2BRateCard;